import React from 'react';
import { compose, withProps } from 'recompose';
import { GoogleMap, Marker, withGoogleMap, withScriptjs } from 'react-google-maps';
import { defaultMapStyle } from 'config/delivery';
import { GoogleMapIcon } from 'assets/images/inline-svg';
import { DelawareMapLink, getGoogleMapKey } from 'config/contacts';

const GoogleMapComponent = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${getGoogleMapKey()}&language=en`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `659px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)(({ currentLocation, isMarkerShown }) => {
  const handleMarkerClick = () => window.open(DelawareMapLink, '_blank');
  return (
    <GoogleMap
      defaultOptions={{
        styles: defaultMapStyle,
        fullscreenControl: false,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
      }}
      defaultZoom={11}
      center={currentLocation}
    >
      {isMarkerShown || (
        <Marker icon={GoogleMapIcon} position={currentLocation} onClick={handleMarkerClick} />
      )}
    </GoogleMap>
  );
});

export default GoogleMapComponent;
